import React from 'react';
import { Text, Button, Card, Layout, Input, Select, SelectOptionType, Tab, TabBar, Icon, Toggle } from '@ui-kitten/components';
import { StyleSheet, View, Platform, ViewStyle } from 'react-native';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { M_CREATE_CAMPAIGN } from './../../data/api/mutation/m_campaigns';
import { Q_GET_CAMPAIGN } from '../../data/api/query/q_campaigns';
import { CardItem } from '../../components/list-items/CardItem';
import { M_CREATE_BASIC_SURVEY, M_CREATE_SURVEY_SECTION_AS_CONTAINER } from '../../data/api/mutation/m_surveys';
import { Campaign, Survey, SurveySection } from '../../data/models/types';
import { ScrollView } from 'react-native-gesture-handler';
import { PageLoadingIndicator, ModalLoadingIndicator } from '../../components/LoadingIndicator';
import { AuthContext } from '../../App';

const HEADER_TOP_MARGIN: number = Platform.OS === 'web' ? 0 : -2;


const useInputChanges = (initialValue = '', initialIsRequired = true) => {
    const [value, setValue] = React.useState(initialValue);
    const [error, setError] = React.useState(undefined);
    const [isRequired, setIsRequired] = React.useState(initialIsRequired);
    return {
        value,
        caption: error,
        status: error ? 'danger' : undefined,
        setError,
        setIsRequired,
        onChangeText: setValue,
    };
};

const useDateInputChanges = (initialValue = new Date()) => {
    const [value, setValue] = React.useState<Date>(initialValue);
    return {
        value: value.toLocaleDateString(),
        rawDate: value,
        onChangeText: setValue,
    };
};

const useSelectChanges = (initialValue = { text: '' }) => {
    const [selectedOption, setValue] = React.useState(initialValue);
    return {
        selectedOption,
        onSelect: setValue,
    };
};

const getTomorrow = () => {
    let date = new Date();
    date.setDate(date.getDate() + 1);
    return date
}


// Poall
// P: poll
// o: of
// a: a
// l: long
// l: length

export default function CreatePollScreen({ navigation, route }): React.ReactElement {
    const { pageSpacerHorizontal,isMediumScreenOrLarger, bodyWidth } = useScreenDimensions();
    const params = route?.params;
    console.log({ navigation, route, params });
    const { user } = React.useContext(AuthContext);
    const campaignRequest = useQuery(Q_GET_CAMPAIGN, { variables: { org_id: user.org_id }, fetchPolicy: 'network-only' });
    console.log(campaignRequest);
    const tomorrow: Date = getTomorrow();
    const [pageReady, setPageReady] = React.useState(false);
    const [modalVisible, setModalVisible] = React.useState(false);
    const titleInput = useInputChanges();
    const descInput = useInputChanges(undefined, false);
    const instructionsInput = useInputChanges(undefined, false);
    const startDateInput = useDateInputChanges();
    const endDateInput = useDateInputChanges(tomorrow);
    const [isPublic, setIsPublic] = React.useState(true);
    const [isOpen, setIsOpen] = React.useState(true);
    const [selectedOption, setSelectedOption] = React.useState<SelectOptionType>(params && params.parentCampaignTitle ? { text: params.parentCampaignTitle, value: params.parentCampaignId } : null);
    const [createSurvey, createSurveyResponse] = useMutation(M_CREATE_BASIC_SURVEY);
    const [createSurveySectionAsContainer, createSurveySectionAsContainerResponse] = useMutation(M_CREATE_SURVEY_SECTION_AS_CONTAINER);

    React.useEffect(() => {
        if (!pageReady) {
            console.log('if (!pageReady) {');
            if (params && params.parentCampaignTitle) {
                console.log('if (params && params.parentCampaignTitle) {');
                // using campaign info passed from prev screen
                setPageReady(true);
            }
            else {
                if (campaignRequest && campaignRequest.data && campaignRequest.data.campaigns && campaignRequest.data.campaigns[0]) {
                    console.log('if (campaignRequest && campaignRequest.data && campaignRequest.data.campaigns && campaignRequest.data.campaigns[0]) {');
                    const campaign: Campaign = campaignRequest.data.campaigns[0];
                    setSelectedOption({ text: campaign.title, value: campaign.id });
                    setPageReady(true);
                }
            }
        }
    });


    if (campaignRequest.loading) {
        return (
            <PageLoadingIndicator />
        );
    }
    if (campaignRequest.error) {
        console.log(`ERROR: const [createSurvey, { data, loading, error }] = useMutation(M_CREATE_CAMPAIGN);`, campaignRequest.error)
        return (
            <>
                <Text>{'There was an error with the request'}</Text>
            </>
        );
    }
    const _goBack = () => { navigation.goBack(); }

    const _checkInputs = () => {
        let inputsValid: boolean = true;
        if (!titleInput.value || titleInput.value.length < 1) {
            titleInput.setError('Title is requried');
            inputsValid = false;
        }
        else {
            titleInput.setError(undefined);
        }

        return inputsValid;
    }

    const _onSubmit = async () => {
        console.log({ titleInput, descInput, instructionsInput });
        try {
            setModalVisible(true);
            let inputsValid: boolean = _checkInputs();
            if (inputsValid === false) {
                setModalVisible(false);
                return;
            }
    
            let surveyParams: any = {
                survey_type_id: BASE_TYPE_IDS.POLL,
                title: titleInput.value,
                description: descInput.value,
                instructions: instructionsInput.value
            };
    
    
            if (user && user.product_plan && user.product_plan.id > 1) {
                console.log('using prem or plat functionality');
                surveyParams.campaign_id = selectedOption.value;
                surveyParams.is_public = isPublic;
                surveyParams.is_open = isOpen;
                surveyParams.start_date = startDateInput.rawDate.toISOString();
                surveyParams.end_date = endDateInput.rawDate.toISOString();
            }
            console.log('using these params for call', surveyParams);
            
            const createSurveyResult: any = await createSurvey({ variables: surveyParams});
            console.log('createSurveyResult', createSurveyResult);
            if (createSurveyResult && createSurveyResult.data &&  createSurveyResult.data.insert_surveys && createSurveyResult.data.insert_surveys.returning && createSurveyResult.data.insert_surveys.returning[0]) {
                const survey: Survey = createSurveyResult.data.insert_surveys.returning[0];
                console.log('Survey created from the response createSurveyResult data', survey);
                const sectionParams: any = {
                    survey_id: survey.id
                };
    
                const createSection: any = await createSurveySectionAsContainer({ variables: sectionParams});
                console.log('createSection', createSection);
                setModalVisible(false);
                navigation.navigate('ManagePoll', { id: survey.id, campaign_id: selectedOption.value });
                return;
            }
            
            // there was an error
            alert('There was an error, please try again. If you keep seeeing this issue, contact your admin');
            setModalVisible(false);
        }
        catch (error) {
            // there was an error
            console.log(error);
            alert('There was an error, please try again. If you keep seeeing this issue, contact your admin');
            setModalVisible(false);
        }
    }

    let selectListData: SelectOptionType[] = campaignRequest.data.campaigns.map((campaign: CardItem) => { return { text: campaign.title, value: campaign.id } });


    const _renderHeader = () => (
        <ListHeader
            title={'Create'}
            isMediumScreenOrLarger={isMediumScreenOrLarger}
            style={{ paddingHorizontal: 0, marginTop: 0, marginBottom: 20 }}
        />
    );
    const _renderFooter = () => (
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginVertical: 30}}>
            <Button onPress={_goBack} status='basic'>{'Cancel'}</Button>
            <Button onPress={_onSubmit}>{` Next `}</Button>
        </View>
    );

    return (
        <Layout level='1' style={{ flex: 1 }}>       
            <ScrollView
                // contentContainerStyle={{ flexGrow: 1 }}
                // style={{ flex: 1 }}
                style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : { paddingHorizontal: pageSpacerHorizontal }}
            >
                <BasicCard style={{ borderWidth: 0 }}>
                    {_renderHeader()}
                    {(user.product_plan.title === 'Premium' || user.product_plan.title === 'Platinum') ?
                        <>
                            <Select
                                data={selectListData}
                                selectedOption={selectedOption}
                                onSelect={setSelectedOption}
                                style={styles.input}
                                size='large'
                                label='Campaign'
                            />
                        </>
                        : undefined
                    }

                    <Input
                        style={styles.input}
                        size='large'
                        placeholder='Poll Title'
                        label='Poll Title'
                        {...titleInput}
                    />
                    <Input
                        style={styles.input}
                        size='large'
                        placeholder='Poll Description'
                        label='Poll Description'
                        {...descInput}
                    />
                    <Input
                        style={styles.input}
                        size='large'
                        placeholder='Poll Instructions'
                        label='Poll Instructions (optional)'
                        {...instructionsInput}
                    />
                    {(user.product_plan.title === 'Premium' || user.product_plan.title === 'Platinum') ?
                        <>
                            <Input
                                style={styles.input}
                                size='large'
                                placeholder='Start Date'
                                label='Start Date'
                                disabled
                                {...startDateInput}
                            />
                            <Input
                                style={styles.input}
                                size='large'
                                placeholder='End Date'
                                label='End Date'
                                disabled
                                {...endDateInput}
                            />
                            <ToggleItem
                                title={`Public:  ${isPublic ? 'Yes' : 'No'}`}
                                description={'Allow anyone with the link to your survey to submit answers (when the survey is open)'}
                                checked={isPublic}
                                onToggle={setIsPublic}
                                style={styles.input}
                            />
                            <ToggleItem
                                title={`Open:  ${isOpen ? 'Yes' : 'No'}`}
                                description={'Allow people to submit answers to this survey (you can toggle this later)'}
                                checked={isOpen}
                                onToggle={setIsOpen}
                                style={styles.input}
                            />
                        </>
                        : undefined
                    }
                    {_renderFooter()}
                </BasicCard>
                <ModalLoadingIndicator modalVisible={modalVisible} />
            </ScrollView>
        </Layout>
    );

}


const styles = StyleSheet.create({
    input: {
        marginVertical: 10
    },
});





const surveyTypeSelectData = [
    { text: 'Basic' },
    {
        text: 'Advanced',
        disabled: true,
    }
];

const selectStyles = StyleSheet.create({
    container: {
        minHeight: 228,
    },
});


interface BasicQuestionTypeSelectProps {
    onSelect: (option: SelectOptionType) => void;
    selected?: string;
    label?: string;
    style?: ViewStyle;
}


class SurveyTypeSelect extends React.Component<BasicQuestionTypeSelectProps, { selectedOptionIndex: number }> {
    constructor(props: Readonly<BasicQuestionTypeSelectProps>) {
        super(props)
        const initialIndex: any = surveyTypeSelectData.findIndex(item => item.text === props.selected);
        this.state = {
            selectedOptionIndex: initialIndex >= 0 ? initialIndex : 0
        }
    };

    _onSelect = (option: SelectOptionType) => {
        const newIndex: any = surveyTypeSelectData.findIndex(item => item.text === option.text);
        console.log(option, newIndex);
        this.setState({ selectedOptionIndex: newIndex });
        this.props.onSelect(option);
    }

    render() {
        const { selectedOptionIndex } = this.state;
        return (
            <Select
                data={surveyTypeSelectData}
                selectedOption={surveyTypeSelectData[selectedOptionIndex]}
                onSelect={this._onSelect}
                style={this.props.style}
                label={this.props.label}
                size='large'
            />
        );
    }
};

const BuildIcon = (style) => (
    <Icon {...style} name='cube-outline' />
);
const PreviewIcon = (style) => (
    <Icon {...style} name='tv-outline' />
);


import {
  CheckBox,
  ListItem,
} from '@ui-kitten/components';

export const ToggleItem = ({ title, description, checked, onToggle, style = undefined }) => {

    const onCheckedChange = (isChecked) => {
        onToggle(isChecked);
    };


    const renderAccessory = (style) => (
        <Toggle
            // text={title}
            checked={checked}
            onChange={onCheckedChange}
            style={[{ justifyContent: 'flex-start' }, style]}
        />
    );


    return (
        <ListItem
            title={title}
            description={description}
            accessory={renderAccessory}
        />
    )
};




import {
    Calendar,
} from '@ui-kitten/components';
import { useScreenDimensions } from '../../utils/useScreenInfo';
import { BASE_TYPES, BASE_TYPE_IDS } from '../../data/models/enums/base_types';
import { BasicCard, ListHeader } from '../../components/_primatives';

export const CalendarSimpleUsageShowcase = () => {

    const [date, setDate] = React.useState(new Date());

    return (
        <Layout style={{ minHeight: 376 }}>

            <Text style={{ marginVertical: 8 }} category='h6'>
                {`Selected date: ${date.toLocaleDateString()}`}
            </Text>

            <Calendar
                date={date}
                onSelect={setDate}
            />

        </Layout>
    );
};
